import Emitter from '../Emitter';
import Commander from '../Commander';
import * as PIXI from "pixi.js-legacy";
import * as particles from 'pixi-particles';
import {pixiClearTimeout, pixiSetTimeout, pixiSetTimeoutAsync} from "../../framework/src/engine/pixi/pixiTimeout";
import {getTweenAsync} from "../../framework/src/modules/Tween";

class WildWin {
    constructor(commander) {
        this.commander = commander;
        this.SymbolAnimations = this.commander.SymbolAnimations;
        this.LineWinAnimations = this.commander.LineWinAnimations;
        this.audio = this.commander.audio;
        this.Emitter = this.commander.Emitter;
        this.reels = this.commander.slots.getReels();
        this.layer = {
            reels: this.commander.layers.reels,
            beam: this.commander.layers.win.children[0],
            wild: this.commander.layers.win.children[1],
            anim: this.commander.layers.win.children[2],
            particles: this.commander.layers.win.children[3],
            numbers: this.commander.layers.win.children[4]
        };


        this.lastTextIndex = this.commander.lastTextIndex;
        this.lineCount = this.commander.lineCount;

        this.emitters = [];
        this.timeOuts = [];
    }

    async run(lineWins, bigwin = false) {
        for (let lineWin of lineWins) {
            if (lineWin.type === "respin") {
                break;
            } else {
                if (!bigwin)
                    this.commander.addWin(lineWin.win);
                this.LineWinAnimations.run(lineWin);
                this.Emitter.emitLine(lineWin.line + 1, Emitter.getDirection(lineWin), lineWin.position.length);
                for (let pos of lineWin.position) {
                    let symbol = this.commander.slots.getResultSymbols()[pos[0] * 3 + pos[1]];
                    await this.SymbolAnimations.run(symbol);
                }
                if (lineWin.position.length < 5)
                    await this.SymbolAnimations.delay(5 - lineWin.position.length);
                this.commander.lineWinsIndex++;
            }
        }
    }

    spread(wildPos) {
        return new Promise(res => {

            let i = 0;
            for (let pos of wildPos) {
                Commander.setAlpha(this.layer.beam, 1, 500);
                let reel = this.commander.slots.getReel(pos[0]);
                reel.data.wild = true;
                let symbols = reel.getResSymbols();
                this.lightBeam(symbols[0].x);
                WildWin.hideReel(reel);
                this.morph(symbols, i++).then(() => {
                    symbols = reel.getResSymbols();
                    symbols.forEach((symbol) => {
                        symbol.name = "symbol_crystal_wild";
                    });
                    res();
                });
            }
        });
    }

    respin(result) {
        return this.commander.spinRespin(result);
    }

    lightBeam(x) {
        return new Promise(res => {
            let lightBeam = Commander.getSprite("light_beam.png", x, 720, {x: 0.5, y: 0});
            lightBeam.alpha = 0.3;
            this.layer.beam.addChild(lightBeam);
            this.audio.fadeInPlaying("bonus_Wild_Start", 1000);

            createjs.Tween.get(lightBeam.position)
                .to({y: -100}, 400, createjs.Ease.linear)
                .call(() => Commander.removeTween(lightBeam.position));
            createjs.Tween.get(lightBeam)
                .to({alpha: 1}, 400, createjs.Ease.linear)
                .call(() => Commander.removeTween(lightBeam))
                .call(res);

            this.beamParticles(x);
        });
    }

    /**
     * Animate appearing of wild symbols and morphing old symbols.
     * Iterate through symbols of the reel, if wild, add to layers.wild.
     * If normal symbol, create and rotate spiral and the old morphed symbol.
     * @param symbols
     * @param sound
     * @return {Promise<any>}
     */
    morph(symbols, sound) {
        return new Promise (async res => {
            let i = symbols.length-1; // for delay
            for (let symbol of symbols) {
                if (symbol.name !== "symbol_crystal_wild") {
                    i--;
                    let newSymbol = this.getSymbol(symbol.name);
                    newSymbol.position.set(symbol.x, symbol.y);
                    this.layer.anim.addChild(newSymbol);
                    pixiSetTimeout(i*.4, () => {
                        if (!sound)
                            this.audio.playTrack("bonus_Wild_Spin");
                        newSymbol.toWild();
                        this.wildParticles(symbol);
                    });
                } else {
                }
            }
            this.timeOuts.push(pixiSetTimeout(2.5, res));
        });
    }

    getSymbol(name) {
        switch(name) {
            case "symbol_crystal_yellow":
                return this.commander.symbols.createByIndex(0, {});
            case "symbol_crystal_blue":
                return this.commander.symbols.createByIndex(1, {});
            case "symbol_crystal_orange":
                return this.commander.symbols.createByIndex(2, {});
            case "symbol_crystal_green":
                return this.commander.symbols.createByIndex(3, {});
            case "symbol_crystal_purple":
                return this.commander.symbols.createByIndex(4, {});
            case "symbol_crystal_seven":
                return this.commander.symbols.createByIndex(5, {});
            case "symbol_crystal_bar":
                return this.commander.symbols.createByIndex(6, {});
            case "symbol_crystal_wild":
                return this.commander.symbols.createByIndex(7, {});
        }
    }

    beamParticles(x) {
        let emitter = new particles.Emitter(this.layer.beam,
            PIXI.Texture.from("particle_blur.png"),
            beamParticlesConfig
        );
        emitter.updateSpawnPos(x-75, 700);

        emitter.emit = true;
        emitter.autoUpdate = true;

        this.emitters.push(emitter);
    }

    wildParticles(symbol) {
        let emitter = new particles.Emitter(
            this.layer.particles,
            PIXI.Texture.from("symbol_crystal_wild_star.png"),
            wildParticlesConfig
        );
        emitter.updateSpawnPos(symbol.x -75, symbol.y-75);

        emitter.emit = true;
        emitter.autoUpdate = true;

        this.emitters.push(emitter);
    }

    symbolMorphOut(newSymbol, symbol) {
        newSymbol.texture = new PIXI.Texture.from(symbol.name+"_morph.png");
        createjs.Tween.get(newSymbol)
            .to({rotation: Math.PI*4}, 433)
            .call(() => Commander.removeTween(newSymbol));
        createjs.Tween.get(newSymbol.scale)
            .to({x: 0, y: 0}, 433, createjs.Ease.quartInOut)
            .call(() => Commander.removeTween(newSymbol.scale));
    }

    cleanUp() {
        this.clearEmitters();
        this.clearTimeouts();
        this.clearBeams();
        this.respinSound = 0;
    }

    removeWildSymbols() {
        this.layer.wild.removeChildren();
    }

    clearEmitters() {
        for (;this.emitters.length > 0;) {
            let emitter = this.emitters.pop();
            emitter.cleanup();
            emitter.destroy();
        }
    }

    clearBeams(callback = () => {}) {
        createjs.Tween.get(this.layer.beam)
            .to({alpha: 0}, 400, createjs.Ease.quadOut)
            .call(() => {
                for (let sprite of this.layer.beam.children) {
                    sprite.destroy();
                }
                this.layer.beam.removeChildren();
                Commander.removeTween(this.layer.beam);
                callback();
            });
    }

    clearTimeouts() {
        for (; this.timeOuts.length > 0;) {
            pixiClearTimeout(this.timeOuts.pop());
        }
    }

    hideReelSymbols(reelX, reelY) {
        for (let symbol of this.layer.wild.children) {
            if (symbol.reelX === reelX && symbol.reelY === reelY) {

            }
        }
    }

    showReels() {
        for (let reel of this.reels) {
            WildWin.showReel(reel);
        }

    }

    // STATIC METHODS

    static getSpiral() {
        let spiral = Commander.getSprite("symbol_crystal_wild_morph.png", 0,5, {x:0.5, y:0.52});
        spiral.scale.set(0,0);
        spiral.name = "spiral";
        return spiral;
    }

    static showReel(reel) {
        for (let symbol of reel.getResSymbols()) {
            symbol.visible = true;
            symbol.alpha = 1;
        }
    }

    static hideReel(reel) {
        for (let symbol of reel.getResSymbols()) {
            symbol.visible = false;
        }
        for (let symbol of reel.getSpinSymbols()) {
            symbol.visible = false;
        }
    }
}
let beamParticlesConfig = {
    "alpha": {
        "start": 0.8,
        "end": 0
    },
    "scale": {
        "start": 1.5,
        "end": 0.25,
        "minimumScaleMultiplier": 1
    },
    "color": {
        "start": "#FFFFFF",
        "end": "#FFFFFF"
    },
    "speed": {
        "start": 750,
        "end": 500,
        "minimumSpeedMultiplier": 1
    },
    "acceleration": {
        "x": 10,
        "y": 0
    },
    "maxSpeed": 0,
    "startRotation": {
        "min": 270,
        "max": 270
    },
    "noRotation": false,
    "rotationSpeed": {
        "min": 0,
        "max": 0
    },
    "lifetime": {
        "min": 1,
        "max": 5
    },
    "blendMode": "normal",
    "frequency": 0.15,
    "emitterLifetime": -1,
    "maxParticles": 60,
    "pos": {
        "x": 0,
        "y": 0
    },
    "addAtBack": false,
    "spawnType": "rect",
    "spawnRect": {
        "x": 0,
        "y": 0,
        "w": 150,
        "h": 50
    }
};
let wildParticlesConfig = {
    "alpha": {
        "list": [
            {
                "value": 0,
                "time": 0
            },
            {
                "value": 1,
                "time": 0.5
            },
            {
                "value": 0,
                "time": 6
            }
        ]
    },
    "scale": {
        "start": 1,
        "end": 0.01,
        "minimumScaleMultiplier": 1
    },
    "color": {
        "start": "#ffffff",
        "end": "#ffffff"
    },
    "speed": {
        "start": 0,
        "end": 0,
        "minimumSpeedMultiplier": 0.001
    },
    "acceleration": {
        "x": 0,
        "y": 0
    },
    "maxSpeed": 0,
    "startRotation": {
        "min": 0,
        "max": 0
    },
    "noRotation": false,
    "rotationSpeed": {
        "min": 0,
        "max": 0
    },
    "lifetime": {
        "min": 0.5,
        "max": 1.5
    },
    "blendMode": "normal",
    "frequency": 0.25,
    "emitterLifetime": -1,
    "maxParticles": 10,
    "pos": {
        "x": 0,
        "y": 0
    },
    "addAtBack": false,
    "spawnType": "rect",
    "spawnRect": {
        "x": 0,
        "y": 0,
        "w": 150,
        "h": 150
    }
};
export default WildWin;